// ============================================================
// api/billingSummary.js — the billing summary + monthly snapshots
// (ruled 2026-08-21). Backend: admin-billing-snapshots.js
// (summary / snapshots list / snapshot detail / snapshot pdf / capture).
// Money is PENCE/INT on the wire.
// ============================================================
import { apiGet, apiGetBlob, apiPost } from './client';

// LIVE view: every active non-demo client's headcounts + modules +
// computed bill (un-configured clients flagged). period = 'YYYY-MM'
// (default current month).
export const getBillingSummary = (period) => apiGet('/mgmt/admin/billing/summary', period ? { period } : {});

// Captured snapshot periods, newest first, with per-period aggregates.
export const listBillingSnapshots = () => apiGet('/mgmt/admin/billing/snapshots');

// One captured period's stored per-client rows.
export const getBillingSnapshot = (period) => apiGet(`/mgmt/admin/billing/snapshots/${encodeURIComponent(period)}`);

// The period's summary document as a PDF Blob (the same document the
// monthly timer emails).
export const downloadBillingSnapshotPdf = (period) => apiGetBlob(`/mgmt/admin/billing/snapshots/${encodeURIComponent(period)}/pdf`);

// Manually (re-)capture a period — idempotent upsert; future periods 400.
export const captureBillingSnapshot = (period) => apiPost(`/mgmt/admin/billing/snapshots/${encodeURIComponent(period)}/capture`, {});
